import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnersComponent } from './partners.component';
import { PartnersRoutingModule } from './partners-routing.module';
import { HeaderComponent } from '@components/header/header.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component';
import { PartnersRecommendedModalComponent } from '@components/partners-recommended-modal/partners-recommended-modal.component';
import { TableComponent } from '@components/table/table.component';
import { PartnersContactModalModule } from '@components/partners-contact-modal/partners-contact-modal.module';
import { SelectComponent } from '@components/select/select.component';
import { SelectPostalComponent } from '@components/select-postal/select-postal.component';

@NgModule({
  declarations: [PartnersComponent],
  imports: [
    CommonModule,
    PartnersRoutingModule,
    HeaderComponent,
    TranslateModule,
    FormsModule,
    ConfirmModalComponent,
    PartnersRecommendedModalComponent,
    PartnersContactModalModule,
    TableComponent,
    SelectComponent,
    SelectPostalComponent
  ]
})
export class PartnersModule {}
